"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _image = _interopRequireDefault(require("./image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createAccountSelection = function createAccountSelection(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    loggedInTitle: (0, _utils.getProp)(fields, 'loggedInTitle'),
    loggedInLabel: (0, _utils.getProp)(fields, 'loggedInLabel'),
    loggedOutTitle: (0, _utils.getProp)(fields, 'loggedOutTitle'),
    loggedOutLabel: (0, _utils.getProp)(fields, 'loggedOutLabel'),
    topSectionImage: (0, _utils.getProp)(fields, 'topSectionImage') ? (0, _image["default"])(fields.topSectionImage) : null,
    topSectionHeader: (0, _utils.getProp)(fields, 'topSectionHeader'),
    topSectionBody: (0, _utils.getProp)(fields, 'topSectionBody'),
    topSectionBullets: (0, _utils.getProp)(fields, 'topSectionBullets') || [],
    topSectionPrimaryButtonText: (0, _utils.getProp)(fields, 'topSectionPrimaryButtonText'),
    topSectionSecondaryButtonText: (0, _utils.getProp)(fields, 'topSectionSecondaryButtonText'),
    separatorText: (0, _utils.getProp)(fields, 'separatorText'),
    bottomSectionHeader: (0, _utils.getProp)(fields, 'bottomSectionHeader'),
    bottomSectionBody: (0, _utils.getProp)(fields, 'bottomSectionBody'),
    bottomSectionPrimaryButtonText: (0, _utils.getProp)(fields, 'bottomSectionPrimaryButtonText')
  };
};
var _default = createAccountSelection;
exports["default"] = _default;